import { Button, ListGroup } from "react-bootstrap";
import formatDollars from "../../../../../utilities/currency-formatter";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import { ExepnditureAccordion, ExepnditureAccordionBody, ExepnditureAccordionToggle, ExepnditureAccordionCollapseSection } from "../../expenditureworksheet/expenditureaccordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import DeleteButton from "../../../../../components/deletebutton";
import useMessageStore from "../../../../../stores/message-store";

const OneTimeCosts = ({ toggleAddEditMode, addEditIndex,refreshFunction, oneTimeCostEntries = [],expenditureTypes = [], canAdd = false, canUpdate = false, canDelete = false }) => {
    const addToast = useMessageStore(state => state.addToast);
        
    const _deleteSuccessCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The Cost was succesfully deleted!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
        
        refreshFunction();
    }
        
    const _deleteErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when deleting the cost.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const totalCalculatedAmount = oneTimeCostEntries.reduce((sum,current) => sum + current.total,0);
    const showEmptyState = !canAdd && oneTimeCostEntries.length === 0;

    return (
        <ExepnditureAccordion>
            <ExepnditureAccordionBody eventKey='0'>
                <ExepnditureAccordionToggle eventKey='0'>
                        <span className='d-flex justify-content-between align-items-center w-100'>
                            <span className='fw-bold'>ONE TIME COSTS</span>
                            <span>{formatDollars(totalCalculatedAmount)}</span>
                    </span>
                </ExepnditureAccordionToggle>
                <ExepnditureAccordionCollapseSection>
                    <ListGroup>
                        {
                            canAdd
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem}`}>
                                    <div className='d-flex justify-content-center'>
                                        <Button type='button' variant='success' size='sm' title="Add One Time Cost" aria-label="Add One Time Cost" style={{ borderRadius: '50%' }} onClick={() => toggleAddEditMode(null, addEditIndex, 'add')}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            showEmptyState
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem} text-center text-muted`}>
                                    No one time costs to display.
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            oneTimeCostEntries.map(oneTimeCost => {
                                const expenseType = expenditureTypes.find(x => `${x.id}` === `${oneTimeCost.expensetypeid}`);

                                return (
                                    <ListGroup.Item key={oneTimeCost.id} className={`${styles.expenditureListItem}`}>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{formatDollars(oneTimeCost.total)}</span>
                                        </div>
                                        <div>
                                            {oneTimeCost.comments}
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span className={styles.expenditureListItemType}>
                                                {expenseType?.name ?? "Type Missing"}
                                            </span>
                                            <span className='d-flex'>
                                                <div>

                                                    <Button size="sm" type="button" variant="primary" className="me-1" title={canUpdate ? "Edit One Time Cost" : "View One Time Cost"} aria-label={canUpdate ? "Edit One Time Cost" : "View One Time Cost"} onClick={() => toggleAddEditMode(oneTimeCost.id, addEditIndex, canUpdate ? 'edit' : 'view')}>
                                                        <FontAwesomeIcon icon={canUpdate ? faPenToSquare : faEye} />
                                                    </Button>
                                                </div>
                                                {
                                                    canDelete
                                                    ?
                                                        <div >
                                                            <DeleteButton
                                                                deleteObject={{CostID: oneTimeCost.id}}
                                                                endpoint='CostEstimate_OneTime_Delete'
                                                                successCallback={_deleteSuccessCallback}
                                                                errorCallback={_deleteErrorCallback}
                                                            />
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                );
                            })
                        }

                    </ListGroup>
                </ExepnditureAccordionCollapseSection>
            </ExepnditureAccordionBody>
        </ExepnditureAccordion>
    )
}

export default OneTimeCosts;
